export default __webpack_public_path__ + "static/media/fish&chips-bold.ed378a0d.woff";